import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Notification, LoadIndicator } from 'COMPONENTS/ui';
import ErrorBoundary from 'COMPONENTS/ErrorBoundary/ErrorBoundary';
import MainLayoutNavBar from './MainLayoutNavBar';
import './MainLayout.less';

const MainLayout = ({ children, sidebar, renderBefore }) => (
  <div className="main-layout">
    <div className="top-nav-container">
      <MainLayoutNavBar />
    </div>
    <div className="main-body">
      <ErrorBoundary>
        <LoadIndicator />
        {typeof renderBefore === 'function' && (
          <div className="main-layout-before">
            { renderBefore() }
          </div>
        )}
        <div className={classnames('content-wrapp', { 'has-sidebar': Boolean(sidebar) })}>
          {sidebar &&
            <div className="sidebar">
              {sidebar}
            </div>}
          <div className="main-content">
            <Notification />
            {children}
          </div>
        </div>
      </ErrorBoundary>
    </div>
  </div>
);

MainLayout.defaultProps = {
  sidebar: null,
  renderBefore: null,
};

MainLayout.propTypes = {
  children: PropTypes.any.isRequired,
  sidebar: PropTypes.element,
  renderBefore: PropTypes.func,
};

export default MainLayout;



// WEBPACK FOOTER //
// ./src/components/Layout/Main/MainLayout.js